<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><img alt="burb" src="image/bird.jpg"/></p>
<h1 class="center">EARLY BIRD BOOKS</h1>
<p class="center"><b>FRESH EBOOK DEALS, DELIVERED DAILY</b></p>
<p class="Basic-Paragraph" style="margin-top:20px;">BE THE FIRST TO KNOW—</p>
<p class="Basic-Paragraph-2" style="margin-top:20px;">NEW DEALS HATCH EVERY DAY!</p>
<p class="center" style="margin-top:20px;"><a href="https://earlybirdbooks.com/?utm_source=EBBGOAAAAE&amp;utm_campaign=9781504021418" target="_blank"><img alt="signup" src="image/signup.jpg"/></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ebadfront.vue?5102c916